"use client";

import { Toolbar, Typography, Box } from '@mui/material';
import Image from 'next/image';
import Link from 'next/link';
import WhatsAppIcon from './buttons/WhatsappIcon';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Inventory2Icon from '@mui/icons-material/Inventory2';

// Import Swiper styles (Required)
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// import { useCart } from '../context/CartContext';

export const Banner = () => {
    const elements = [
        { text: "FREE DELIVERY as From 800Rs.", icon: <LocalShippingIcon className="text-yellow-500" /> },
        { text: "Express delivery! Receive your order within 2 to 5 business days.", icon: <RocketLaunchIcon className="text-yellow-500" /> },
        { text: "Limited stock! Order now before it's gone.", icon: <Inventory2Icon className="text-yellow-500" /> }
    ];

    // const { cart } = useCart();

    // Calculate total quantity
    // const totalQuantity = cart.reduce((sum, item) => sum + item.quantity, 0);

    return (
        <Box>
            <div className="bg-black">
                <Swiper
                    spaceBetween={30}
                    slidesPerView={1}
                    navigation={false}
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    loop={true}
                    modules={[Autoplay]}
                    className="w-full"
                >
                    {elements.map((el, index) => (
                        <SwiperSlide key={index}>
                            <div
                                className="flex items-center justify-center text-center text-[#FFF7A7] font-bold border-b border-gray-700"
                                style={{ minHeight: '3rem' }}
                            >
                                <div className="flex items-center gap-2 px-4">
                                    <span className="text-yellow-500 text-lg md:text-xl">{el.icon}</span>
                                    <span className="text-sm md:text-base lg:text-lg">{el.text}</span>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className='container mx-auto'>
                <Toolbar sx={{ paddingLeft: '0 !important', paddingRight: '0 !important' }}>
                    {/* Logo */}

                    <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, fontSize: '2rem', fontWeight: '100' }}>
                        <Link href={`/`} style={{ color: 'rgb(97 23 16)', textDecoration: 'none' }}>

                            <div className='inline-flex'>
                                {/* <Image src="/images/logo.png" alt="" width={48} height={50} style={{
                                    position: 'relative',
                                    top: '7px',
                                    marginRight: '1rem'
                                }} /> */}
                                {/* all<strong>promo</strong>.mu */}

                                <span className='relative top-[13px] right-[0]'>
                                    <Image src="/images/logo-text.png" width={200} height={50} alt='logo text'></Image>
                                    {/* <strong>allpromo.mu</strong> */}
                                </span>

                            </div>

                        </Link>
                    </Typography>


                    {/* Boutons d'actions */}
                    <div style={{ marginRight: '3rem' }}>
                        {/* <ShoppingBasketIcon sx={{ fontSize: '3rem', mr: '1rem' }} /> */}
                        {/* <Link href={'/cart'}>
                            <Badge
                                badgeContent={totalQuantity}
                                color="secondary"
                                sx={{
                                    '.MuiBadge-badge': {
                                        backgroundColor: 'red', 
                                        color: 'white', 
                                        fontWeight: 'bold',
                                        fontSize: '0.75rem',
                                    },
                                }}
                            >
                                <ShoppingBasketIcon sx={{ fontSize: '3rem', mr: 'rem' }} />
                            </Badge>
                        </Link> */}




                    </div>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <WhatsAppIcon />
                    </Box>
                </Toolbar>
            </div>

        </Box>

    )
}
